<script setup>
import BpmnSpeed from "@/components/BpmnSpeed.vue";
import OperationLog from "@/components/OperationLog.vue";
import { reactive, ref } from "vue";
import {
  getBackNodes,
  startFormInfo,
  taskOperationLog,
  historyFormData,
} from "@/api/myInitiative";
import { completeTask, dealtTaskInfo } from "@/api/myToDoList";
import { ElMessage } from "element-plus";

const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);
// 遮罩
const loading = ref(false);
// 历史记录列表
const operationLog = ref([]);
// tab默认选中
const activeName = ref("first");
// 流程组件ref
const bpmnSpeed = ref(null);
// 自定义表单渲染ref
const vFormRenderRef = ref(null);
// 待办任务表单
const vFormRenderRef_deal = ref(null);
// 是否驳回
const isBack = ref(false);
// 是否开始节点
const isStarterTask = ref(false);
//实例id
const instanceId = ref(null);
// 节点id
const taskId = ref(null);
// 节点发起人
const starter = ref(null);
// 流程名称
const definitionName = ref(null);
// 流程字符串
const xmlStr = ref("");
// 表单key
const formKey = ref("");
// 表单json
const formConf = ref({
  fields: [],
  formRef: "elForm",
  formModel: "formData",
  size: "medium",
  labelPosition: "right",
  labelWidth: 100,
  formRules: "rules",
  gutter: 15,
  disabled: false,
  span: 24,
  formBtns: false,
});
// 表单数据
const formData = reactive({});
// 驳回
const backNodes = ref([]);
// 开始表单
const startForm = reactive({
  startFormConf: {
    fields: [],
    formRef: "elForm",
    formModel: "formData",
    size: "medium",
    labelPosition: "right",
    labelWidth: 100,
    formRules: "rules",
    gutter: 15,
    disabled: false,
    span: 24,
    formBtns: false,
  },
  formData: {},
  taskId: "",
  key1: +new Date(),
});

// 弹窗打开
const handleDialogOpen = (id) => {
  taskId.value = id;
  visible.value = true;
  viewForm();
};

// 获取提交记录
const getTaskOperationLog = () => {
  operationLog.value = [];
  taskOperationLog(instanceId.value).then((res) => {
    const arr = res.data.value;
    const newOperationLog = [];
    for (let i = 0; i < arr.length; i++) {
      var log = arr[i];
      newOperationLog.push(eval(`(${log})`));
    }
    newOperationLog.map((i) => {
      i = JSON.parse(i);
    });
    operationLog.value = newOperationLog;
  });
};
// 初始化开始表单
const initStartForm = () => {
  startFormInfo(instanceId.value).then((res) => {
    const obj = res.data;
    if (obj.formContent) {
      startForm.startFormConf = JSON.parse(obj.formContent);
      startForm.taskId = obj.taskId;
      historyFormData(startForm.taskId)
        .then((res) => {
          startForm.formData = convertToJsonObj(res.data);
          vFormRenderRef.value.setFormJson(startForm.startFormConf);
        })
        .finally(() => {
          vFormRenderRef.value.setFormData(startForm.formData);
          vFormRenderRef.value.disableForm();
        });
    }
  });
};

// 渲染表单
const viewForm = () => {
  loading.value = true;
  dealtTaskInfo(taskId.value)
    .then((res) => {
      const obj = res.data;
      isBack.value = obj.backFlag;
      isStarterTask.value = obj.starterTaskFlag;
      formKey.value = obj.formKey;
      starter.value = obj.starter;
      instanceId.value = obj.instanceId;
      taskId.value = obj.taskId;
      definitionName.value = obj.definitionName;
      formConf.value = JSON.parse(obj.content);
      xmlStr.value = obj.xmlStr;
      initBackNodes();
      initStartForm();
      getTaskOperationLog();
    })
    .finally(() => {
      vFormRenderRef_deal.value.setFormJson(formConf.value);
      loading.value = false;
    });
};

const initBackNodes = () => {
  getBackNodes(instanceId.value).then((res) => {
    let arr = res.data;
    for (let i = 0; i < arr.length; i++) {
      backNodes.value.push({
        value: arr[i].activityId,
        label: arr[i].activityName,
      });
    }
  });
};

const convertToJsonObj = (arr) => {
  let obj = {};
  if (!Array.isArray(arr)) {
    return obj;
  }
  for (let i = 0; i < arr.length; i++) {
    let current = arr[i];
    obj[current.name] = current.textValue;
  }
  return obj;
};

const resetBpmn = (tab, event) => {
  if (tab.index == "1") {
    bpmnSpeed.value?.resetBpmn();
  }
};

const formSubmit = () => {
  vFormRenderRef_deal.value.getFormData().then((res) => {
    let data = res;
    Object.getOwnPropertyNames(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        data[key] = data[key].join();
      }
    });
    data.taskId = taskId.value;
    data.formKey = formKey.value;
    if (isStarterTask.value) {
      data.starterTask = "starterTask";
    }
    completeTask(data).then((res) => {
      if (res.code == "2000") {
        ElMessage.success("处理成功");
        visible.value = false;
        emits("afterSave");
      }
    });
  });
};

defineExpose({
  handleDialogOpen,
});
</script>

<template>
  <el-dialog
    title="处理任务"
    width="55%"
    :close-on-click-modal="false"
    v-model="visible"
  >
    <div v-loading="loading">
      <el-row class="header">
        <el-col :span="6"><b>提交人：</b>{{ starter }}</el-col>
        <el-col :span="12"><b>流程名称：</b>{{ definitionName }}</el-col>
      </el-row>
      <div style="background-color: white">
        <el-tabs v-model="activeName" type="border-card" @tab-click="resetBpmn">
          <el-tab-pane label="表单信息" name="first">
            <el-row class="formDiv" v-if="!isBack || !isStarterTask">
              <div class="h-title">流程发起表单</div>
              <v-form-render
                ref="vFormRenderRef"
                :form-json="startForm.startFormConf"
                :form-data="startForm.formData"
              />
            </el-row>
            <div class="split"></div>
            <div>
              <div class="h-title-red">待办任务</div>
              <v-form-render
                ref="vFormRenderRef_deal"
                :form-json="formConf"
                :form-data="formData"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="进度查看" name="second">
            <BpmnSpeed
              ref="bpmnSpeed"
              :xmlStr="xmlStr"
              :instanceId="instanceId"
            />
          </el-tab-pane>
          <el-tab-pane label="提交记录" name="third">
            <OperationLog :operationLog="operationLog" :backnodes="backNodes" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <template #footer>
      <el-button type="primary" @click="formSubmit">提交</el-button>
      <el-button type="info" @click="visible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>
.startForm-container {
  padding: 10px 10%;
  min-height: calc(100vh - 75px);
  background-color: #f3f3f3;
  margin-top: -10px;
}
.header {
  width: 100%;
  background: #fff;
  border-radius: 4px;
  margin: 10px 0;
  padding: 20px 20px;
  /*box-shadow: 1px 1px 3px rgb(0 0 0 / 20%);*/
  overflow: hidden;
}
.formDiv {
  width: 100%;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 20px;
  overflow: hidden;
}
.header > div {
  line-height: 34px;
}
.act-btn-tool {
  text-align: right;
}
.h-title {
  border-left: 5px solid #1a7bb9;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
.h-title-red {
  border-left: 5px solid red;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
.split {
  height: 0px;
  border-bottom: 2px #ccc;
  border-bottom-style: dashed;
  margin: 0 4%;
}
</style>
